<template>
    <div class="lang arabic">
        <div class="info">
            <h3 class="bullet01">عملية العلاج في المستشفى (الجدولة)</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">الخطوة الأولى</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">تقييم للعلاج في المستشفى وتحديد مواعيد الدخول،</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">الخطوة الثانية</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">تسليم الرسائل القصيرة لإخطارك بالوقت المتاح للعلاج في المستشفى ودرجات الغرفة المتوفرة (في يوم العلاج في المستشفى)،</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">الخطوة الثالثة</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">العملية الإدارية وقبول الجناح في المستشفى.</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">تقييم للعلاج في المستشفى وتحديد مواعيد الدخول</h4>
            <p class="depth">إذا تقرر أن العلاج في المستشفى ضروري للمريض عند علاجه في القسم أو كخدمة طبية طارئة ، يقوم الطبيب المسؤول/الطبيب المعالج بإدخال تاريخ العلاج في النظام.</p>
            <p class="depth">وبعد ذلك سوف يسجل المريض والوصي عليه الوصول في يوم الدخول وتحديد موعد الإقامة في المستشفى/الخروج منها (غرفة الطوارئ) في مكتب الإدارة.</p>
            <h4 class="depth bullet02">تسليم رسالة الإخطار في عملية الدخول (في يوم الدخول إلى المستشفى)</h4>
            <p class="depth">بمجرد تخصيص غرفة في يوم الدخول إلى المستشفى، سيتم تسليم رسالة عبر الإنترنت، أو رسالة نصية لإعلامك بوقت تسجيل الوصول ودرجات الغرفة المتوفرة.</p>
            <p class="depth">سيتم تحديد الغرفة بناء على الظروف، مثل ما هو متاح في يوم الدخول إلى المستشفى وكذلك المرضى الذين تم خروجهم من المستشفى. لذلك ، قد تختلف درجة جودة الغرفة التي يتم تقديمها في يوم الدخول عن المستوى المطلوب</p>
            <h4 class="depth bullet02">عملية الإدخال إلى المستشفى وتسجيل الوصول</h4>
            <p class="depth">في يوم الإدخال، إذا تلقيت رسالة إشعار عن دخول المستشفى، يجب عليك زيارة المستشفى في الوقت المحدد وإكمال اتفاقية المرضى الداخليين بدخول المستشفى/ الخروج منها في مكتب الإدارة.</p>
            <p class="depth">أما المرضى الذين أكملوا عملية تسجيل الوصول فسيتوجهون إلى الجناح الذي توجد فيه الغرفة المخصصة ، كما ستوجههم الممرضة المسؤولة إلى الغرفة.</p>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: calc(100% / 3)">
                        <col style="width: calc(100% / 3)">
                        <col style="width: calc(100% / 3)">
                    </colgroup>
                    <thead>
                        <tr>
                            <th colspan="3">المستلزمات التي يجب تحضيرها لدخول المستشفى</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="left">
                                والأشياء الشخصية بما في ذلك مستلزمات النظافة والمناشف والأكواب والأحذية الداخلية وورق التواليت وغيرها، والفراش للوصي.
                            </td>
                            <td class="left">
                                <p>العلاج قبل الدخول إلى المستشفى (الذي سيتم إعداده)</p>
                                <p class="bullet03">
                                    أحضر أي دواء قبل الدخول إلى المستشفى بالإضافة إلى الوصفة الطبية المتعلقة. إذا كنت تحضر الدواء، فلا تتناوله من تلقاء نفسك حتى يتخذ الطبيب المسؤول/الطبيب المعالج قرارا بذلك.
                                </p>
                                <p class="bullet03">
                                    أما إذا كان الأمر ضرورياً فيمكن استبدال الدواء بالوصفة الطبية داخل المستشفى.
                                </p>
                            </td>
                            <td class="left">
                                للوقاية من العدوى وحوادث الحريق والسلامة، فإن استخدام المرطب، وعاء القهوة الكهربائي، المروحة، السخان الكهربائي مثل البطانيات الكهربائية، والمواد المشتعلة/ والقابلة للاشتعال محظورة.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="mt10 font-sub">
                ※ إ ذا كنت ترغب في إصدار شهادة طبية و/أو سجل طبي و/أو شهادة قبول/خروج من المستشفى، يرجى تقديم هويتك. 
                <br>
                (ملاحظة: يجب على الأحداث الذين تقل أعمارهم عن 14 عاما أن يقدموا بطاقة هوية ولي الأمر وشهادة علاقات عائلية حالية (نسخة معتمدة من سجل الأسرة وشهادة الأسرة.))
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">الخروج من المستشفى</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">الخطوة الأولى</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">الخطوة الأولى. تقييم الخروج</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">الخطوة الثانية</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">الخطوة الثانية. تذكيرات عند الخروج</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">الخطوة الثالثة</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">الخطوة الثالثة. فحص التأمين</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">الخطوة الرابعة</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">الخطوة الرابعة. الدفع</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">الخطوة الخامسة</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">الخطوة الخامسة. إيصال استلام الدواء.</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">تقييم الخروج من المستشفى</h4>
            <p class="depth ">يتخذ الطبيب المسئول/ الطبيب المعالج القرار النهائي بالخروج من المستشفى في نفس يوم الخروج أو اليوم السابق له.</p>
            <h4 class="depth bullet02 mt20">تذكيرات عند الخروج</h4>
            <p class="depth ">سوف تذكرك الممرضة الخاصه بك بالجدول الواجب اتباعه بما في ذلك العيادات الخارجية / العلاج في المستشفى وفحوصات العيادات الخارجية، وتنظيم السجل الطبي.</p>
            <h4 class="depth bullet02 mt20">فحص التأمين</h4>
            <p class="depth ">بمجرد تسوية فحص التأمين وتنظيم السجل الطبي سيقوم فريق المراجعة بمراجعة التأمين على الوصفة الطبية الخاصة بك</p>
            <h4 class="depth bullet02 mt20">الدفع</h4>
            <p class="depth ">بعد أن يستكمل فريق مراجعة التأمين مراجعة الدفع ، سيتم إرسال رسالة نصية قصيرة إلى المريض أو الوصي. بعد ذلك، يجوز للمريض تسديد المبلغ في مكتب العلاج بالمستشفى / الخروج منها التابع لمكتب الإدارة أو في كشك الدفع في الجناح (للقبول / الخروج).</p>
            <h4 class="depth bullet02 mt20">. استلام الدواء</h4>
            <p class="depth ">وقبل عودة المريض إلى المنزل، سوف تفسر الممرضة بضعة أمور يجب أخدها في الاعتبار، بما في ذلك نظام الدواء.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">دفع الرسوم الطبية المؤقتة</h3>
            <h4 class="depth bullet02">مراجعة ودفع الرسوم الطبية المؤقتة</h4>
            <p class="depth">
                مراجعة ودفع الرسوم الطبية المؤقتة في مكتب الإقامة في المستشفى. أو في أكشاك الدفع في الجناح. ويشير هذا المبلغ إلى ما تم إدخاله في النظام حتى اليوم السابق (الذي لم يستعرض بعد) ومن ثم فقد يختلف عن المبلغ الفعلي الذي يلزم دفعه عند الخروج.
            </p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>